import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const IDLE = 0.55; // motor en marcha antes de arrancar
const DRIVE = 1.1; // aceleración hasta salir
const ACCEL: [number, number, number, number] = [0.55, 0, 0.85, 0.4];
function CarOutline({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 120 40" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-118" data-mp="jqq5jz4ldaya">
      <path d="M6 30 C4 25 8 22 16 21 L34 19 C43 12 53 8 66 8 C79 8 88 12 97 18 L108 21 C114 22 117 25 115 30" data-id="element-119" data-mp="1cf5f464yf128" />
      <path d="M40 19 C50 13 59 11 68 11 C78 11 85 14 91 18.5" data-id="element-120" data-mp="yo0lpls6j50c" />
      <path d="M38 30 H84" data-id="element-121" data-mp="12osxaloixlzs" />
      <path d="M100 30 H115" data-id="element-122" data-mp="12o11b9r0lm8z" />
      <path d="M6 30 H22" data-id="element-123" data-mp="12n9ikziinj04" />
      <circle cx="30" cy="30" r="6.5" data-id="element-124" data-mp="12mg8bokcmbd8" />
      <circle cx="92" cy="30" r="6.5" data-id="element-125" data-mp="1qe52zbkn7bxc" />
    </svg>;
}
export function CatalogTitle() {
  const reduce = useReducedMotion();
  const [run, setRun] = useState(0);
  return <div className="inline-block" onMouseEnter={() => !reduce && setRun(n => n + 1)} data-id="element-126" data-mp="96m3x09dg2b2">
      <h1 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl" data-id="element-127" data-mp="47srzc9qgjd0">
        CATALOGO DE <span className="text-neon" data-id="element-128" data-mp="iwynap5g9pfm">VEHICULOS</span>
      </h1>

      <div key={run} className="relative mt-4 h-10 sm:h-12" data-id="element-129" data-mp="iyi5wmekwckk">
        {/* Subrayado neón: se dibuja detrás del auto, como una estela */}
        <motion.div className="absolute bottom-0 left-0 h-[3px] w-full origin-left rounded-full bg-neon shadow-[0_0_8px_rgba(43,123,255,0.9),0_0_22px_rgba(43,123,255,0.6)]" initial={reduce ? false : {
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        delay: IDLE,
        duration: DRIVE,
        ease: ACCEL
      }} data-id="element-130" data-mp="rwlr1hlnj7bu" />

        {/* Auto del logo */}
        <motion.div className="absolute bottom-[3px] w-16 text-neon drop-shadow-[0_0_6px_rgba(43,123,255,0.9)] sm:w-20" initial={reduce ? false : {
        left: '0%',
        x: '0%',
        opacity: 1
      }} animate={reduce ? {
        left: '100%',
        x: '-100%'
      } : {
        left: '100%',
        x: '20%',
        opacity: [1, 1, 0]
      }} transition={{
        delay: IDLE,
        duration: DRIVE,
        ease: ACCEL,
        opacity: {
          delay: IDLE,
          duration: DRIVE,
          times: [0, 0.85, 1]
        }
      }} data-id="element-131" data-mp="33mo1czybx779">
          {/* vibración del motor en marcha */}
          <motion.div animate={reduce ? undefined : {
          y: [0, -1, 0, -1, 0, -0.5, 0]
        }} transition={{
          duration: IDLE,
          ease: 'linear'
        }} data-id="element-132" data-mp="1glr66b5txcej">
            <CarOutline className="w-full" data-id="element-133" data-mp="1qhlvtq8h07qt" />
          </motion.div>

          {/* humo del escape al arrancar */}
          {!reduce && [0, 1, 2].map(i => <motion.span key={i} className="absolute bottom-1 left-0 h-2 w-2 rounded-full bg-neon/50" initial={{
          opacity: 0,
          x: 0,
          scale: 0.96
        }} animate={{
          opacity: [0, 0.8, 0],
          x: -18 - i * 8,
          scale: 1.8
        }} transition={{
          delay: 0.1 + i * 0.12,
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-134" data-mp="1zbh0kx5ojw5x" />)}
        </motion.div>
      </div>
    </div>;
}